function updateSubtotalPDPHandler(executeImmediately = false) {
  const container = document.querySelector('.js-product');
  const quantityInput = container.querySelector('.wc-pdp-prduct-form .qty-input__input');
  const unitPrice = container.querySelector('.product-info-column-1 .product-info__unit-price');
  const subtotalPrice = container.querySelector('.product-info-column-2 .product-price');

  console.log(quantityInput, 'quantityInput')
  console.log(unitPrice, 'unitPrice')
  console.log(subtotalPrice, 'subtotalPrice')
  if (!quantityInput || !unitPrice || !subtotalPrice) return;

  // Function to parse price from text (removes currency symbols and commas)
  const parsePrice = (priceText) => {
    return parseFloat(priceText.replace(/[^0-9.]/g, ''));
  };

  // Function to format price with currency
  const formatPrice = (price) => {
    return `$${price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };

  // Function to get unit price based on HTML structure
  const getUnitPriceInfo = () => {
    // Check for Case 2: price__current structure
    const priceCurrentElement = unitPrice.querySelector('.price__current');
    if (priceCurrentElement) {
      const currentPrice = parsePrice(priceCurrentElement.textContent);
      const wasElement = unitPrice.querySelector('.price__was');
      const wasPrice = wasElement ? parsePrice(wasElement.textContent) : null;
      return { currentPrice, wasPrice, case: 2 };
    }

    // Check for Case 1: span with inline styles
    const bssSpan = unitPrice.querySelector('span[bss-b2b-product-id]');
    if (bssSpan) {
      const spans = bssSpan.querySelectorAll('span');
      if (spans.length >= 2) {
        // First span is crossed out (was price), second is current price
        const wasPrice = parsePrice(spans[0].textContent);
        const currentPrice = parsePrice(spans[1].textContent);
        return { currentPrice, wasPrice, case: 1 };
      } else if (spans.length === 1) {
        // Only current price
        const currentPrice = parsePrice(spans[0].textContent);
        return { currentPrice, wasPrice: null, case: 1 };
      }
    }

    return null;
  };

  // Function to update subtotal based on case
  const updateSubtotal = () => {
    const quantity = parseInt(quantityInput.value) || 1;
    console.log(quantity, 'quantity')
    const priceInfo = getUnitPriceInfo();
    
    if (!priceInfo) return;

    const newSubtotal = priceInfo.currentPrice * quantity;
    const newSubtotalFormatted = formatPrice(newSubtotal);

    // Find the subtotal price container
    const subtotalContainer = subtotalPrice;
    if (!subtotalContainer) return;

    if (priceInfo.case === 2) {
      // Case 2: Update using data attributes and class selectors
      const subtotalCurrent = subtotalContainer.querySelector('[data-subtotal-price]');
      if (subtotalCurrent) {
        subtotalCurrent.textContent = newSubtotalFormatted;
      }

      if (priceInfo.wasPrice) {
        const newWasSubtotal = priceInfo.wasPrice * quantity;
        const subtotalWas = subtotalContainer.querySelector('[data-subtotal-member-price-was]');
        if (subtotalWas) {
          subtotalWas.textContent = formatPrice(newWasSubtotal);
          subtotalWas.setAttribute('data-subtotal-member-price-was-value', quantity);
        }
      }
    } else if (priceInfo.case === 1) {
      // Case 1: Update span structure with inline styles
      const bssSpan = subtotalContainer.querySelector('span[bss-b2b-product-id]') || 
                     subtotalContainer.querySelector('div[bss-b2b-product-id]');
      if (bssSpan) {
        if (priceInfo.wasPrice) {
          const newWasSubtotal = priceInfo.wasPrice * quantity;
          bssSpan.innerHTML = `<span style="text-decoration: line-through; margin-right: 10px; color: #5984c9;">${formatPrice(newWasSubtotal)}</span><span style="color: #3361ac;">${newSubtotalFormatted}</span>`;
        } else {
          bssSpan.innerHTML = `<span>${newSubtotalFormatted}</span>`;
        }
      }
    }
  };

  console.log('updateSubtotalPDPHandler')

  // Add event listener for quantity changes
  quantityInput.addEventListener('input', updateSubtotal);
  quantityInput.addEventListener('change', updateSubtotal);

  if (executeImmediately) {
    updateSubtotal();
  }
}

function updateSubtotalQuickAddHandler(executeImmediately = false) {
  const container = document.querySelector('.js-product.quick-add-drawer');
  const quantityInput = container.querySelector('.js-product-form .qty-input__input');
  const unitPrice = container.querySelector('.js-product-details .quick-add-info__details');
  const subtotalPrice = container.querySelector('.product-info__group .quick-add-subtotal-info');

  if (!quantityInput || !unitPrice || !subtotalPrice) return;

  function temporaryHideSubtotal() {
    const bssPriceEl = subtotalPrice.querySelector('[bss-b2b-product-price]');
    if (bssPriceEl) {
      bssPriceEl.style.opacity = '0';
    }
  }

  function showSubtotal() {
    const bssPriceEl = subtotalPrice.querySelector('[bss-b2b-product-price]');
    if (bssPriceEl) {
      bssPriceEl.style.opacity = '1';
    }
  }

  quantityInput.removeAttribute('bss-b2b-product-trigger-added');
  // Function to parse price from text (removes currency symbols and commas)
  const parsePrice = (priceText) => {
    return parseFloat(priceText.replace(/[^0-9.]/g, ''));
  };

  // Function to format price with currency
  const formatPrice = (price) => {
    return `$${price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };

  // Function to get unit price based on HTML structure
  const getUnitPriceInfo = () => {
    const priceContainer = unitPrice.querySelector('.product-price');
    if (!priceContainer) return null;

    // Check for Case 2: price__current structure
    const priceCurrentElement = priceContainer.querySelector('.price__current');
    if (priceCurrentElement) {
      const currentPrice = parsePrice(priceCurrentElement.textContent);
      const wasElement = priceContainer.querySelector('.price__was');
      const wasPrice = wasElement ? parsePrice(wasElement.textContent) : null;
      return { currentPrice, wasPrice, case: 2 };
    }

    // Check for Case 1: span with inline styles
    const spans = priceContainer.querySelectorAll('span');
    if (spans.length >= 2) {
      // First span is crossed out (was price), second is current price
      const wasPrice = parsePrice(spans[0].textContent);
      const currentPrice = parsePrice(spans[1].textContent);
      return { currentPrice, wasPrice, case: 1 };
    } else if (spans.length === 1) {
      // Only current price
      const currentPrice = parsePrice(spans[0].textContent);
      return { currentPrice, wasPrice: null, case: 1 };
    }

    return null;
  };

  // Function to update subtotal based on case
  const updateSubtotal = () => {
    const quantity = parseInt(quantityInput.value) || 1;
    const priceInfo = getUnitPriceInfo();
    
    if (!priceInfo) return;

    const newSubtotal = priceInfo.currentPrice * quantity;
    const newSubtotalFormatted = formatPrice(newSubtotal);

    // Show the subtotal container if it's hidden
    if (subtotalPrice.classList.contains('hidden')) {
      subtotalPrice.classList.remove('hidden');
    }

    if (priceInfo.case === 2) {
      // Case 2: Update using data attributes and class selectors
      const subtotalCurrent = subtotalPrice.querySelector('[data-subtotal-price]');
      if (subtotalCurrent) {
        subtotalCurrent.textContent = newSubtotalFormatted;
      }

      if (priceInfo.wasPrice) {
        const newWasSubtotal = priceInfo.wasPrice * quantity;
        const subtotalWas = subtotalPrice.querySelector('[data-subtotal-member-price-was]');
        if (subtotalWas) {
          subtotalWas.textContent = formatPrice(newWasSubtotal);
          subtotalWas.setAttribute('data-subtotal-member-price-was-value', quantity);
        }
      }
    } else if (priceInfo.case === 1) {
      // Case 1: Update span structure with inline styles
      const bssSpan = subtotalPrice.querySelector('span[bss-b2b-product-id]');
      
      if (bssSpan) {
        if (priceInfo.wasPrice) {
          const newWasSubtotal = priceInfo.wasPrice * quantity;
          bssSpan.innerHTML = `<span style="text-decoration: line-through; margin-right: 10px; color: #5984c9;">${formatPrice(newWasSubtotal)}</span><span style="color: #3361ac;">${newSubtotalFormatted}</span>`;
        } else {
          bssSpan.innerHTML = `<span>${newSubtotalFormatted}</span>`;
        }
      }

      showSubtotal();
    }
  };

  const executeUpdateSubtotal = () => {
    const priceInfo = getUnitPriceInfo();
    if (priceInfo.case === 1) {
      temporaryHideSubtotal();
      setTimeout(updateSubtotal, 1000)
    } else {
      updateSubtotal();
    }
  }

  // Add event listener for quantity changes
  quantityInput.addEventListener('input', executeUpdateSubtotal);
  quantityInput.addEventListener('change', executeUpdateSubtotal);

  if (executeImmediately) {
    executeUpdateSubtotal();
  }
}

document.addEventListener('wc-init:subtotal-pdp-update', () => {
  updateSubtotalPDPHandler();
});

document.addEventListener('wc-init:subtotal-quick-add-update', () => {
  updateSubtotalQuickAddHandler();
});

document.addEventListener('wc-init:subtotal-quick-add-update-immediately', () => {
  updateSubtotalQuickAddHandler(true);
});